import dayjs from 'dayjs';
import enLocale from 'dayjs/locale/en';
import esLocale from 'dayjs/locale/es';
import frLocale from 'dayjs/locale/fr';
import itLocale from 'dayjs/locale/it';
import krLocale from 'dayjs/locale/ko';
import ruLocale from 'dayjs/locale/ru';
import ukLocale from 'dayjs/locale/uk';
import cnLocale from 'dayjs/locale/zh-cn';
import updateLocale from 'dayjs/plugin/updateLocale';

import { enLocale as customizedEnLocale } from 'src/dayjs-locales/en-US';
import { esLocale as customizedEsLocale } from 'src/dayjs-locales/es-419';
import { frLocale as customizedFrLocale } from 'src/dayjs-locales/fr-FR';
import { itLocale as customizedItLocale } from 'src/dayjs-locales/it-IT';
import { krLocale as customizedKrLocale } from 'src/dayjs-locales/ko-KR';
import { ruLocale as customizedRuLocale } from 'src/dayjs-locales/ru-RU';
import { ukLocale as customizedUkLocale } from 'src/dayjs-locales/uk-UA';
import { cnLocale as customizedCnLocale } from 'src/dayjs-locales/zh-CN';
import { LOCALES } from 'src/interfaces/i18n.types';

dayjs.extend(updateLocale);

// overwrite the locales
dayjs.locale(LOCALES.EN, { ...enLocale, ...customizedEnLocale });
dayjs.locale(LOCALES.ES, { ...esLocale, ...customizedEsLocale });
dayjs.locale(LOCALES.FR, { ...frLocale, ...customizedFrLocale });
dayjs.locale(LOCALES.IT, { ...itLocale, ...customizedItLocale });
dayjs.locale(LOCALES.UA, { ...ukLocale, ...customizedUkLocale });
dayjs.locale(LOCALES.RU, { ...ruLocale, ...customizedRuLocale });
dayjs.locale(LOCALES.KR, { ...krLocale, ...customizedKrLocale });
dayjs.locale(LOCALES.CN, { ...cnLocale, ...customizedCnLocale });

// set default locale to English
dayjs.locale(LOCALES.EN);

export { dayjs };
